import React, { useState } from 'react'
import { FaPlus } from 'react-icons/fa6'
import PadContainer from '../../../components/PadContainer'
import TitleContainer from '../../../components/TitleContainer'
import { Avatar, Button, Divider, Drawer, Dropdown, Form, Image, Input, Switch, Tag } from 'antd'
import eventImage from '../../../assets/gallery/event.png'
import { handleConfirm, handleTableSelect, statusType } from '../../../context/utils'
import CustomTable from '../../../components/CustomTable'
import { PiDotsThreeOutlineBold } from 'react-icons/pi'
import { BiEdit, BiUser } from 'react-icons/bi'
import { GoTrash } from 'react-icons/go'
import { ImStopwatch } from 'react-icons/im'
import { CiCalendarDate, CiLocationOn } from 'react-icons/ci'
import { useDeleteProductColor, useGetProductColors, usePatchProductColor, usePostProductColor } from '../../../hooks/productColor/productColor'

function ProductColorTab() {
  const [createPayload, setCreatePayload] = useState({
    name:"",
    color:"",
    id:""
  })
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [isViewOpen, setIsViewOpen] = useState(false)
  const onCreateOpen = () => setIsCreateOpen(true)
  const onViewClose = () => setIsViewOpen(false)
//   const onViewOpen = () => setIsViewOpen(true)
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const [selected, setSelected] = useState({})
  const [rows, setRows] = useState([])
  const width = window.innerWidth
  const isMobile = width <= 500
  const [form] = Form.useForm()
  
  const onCloseEdit = () => {
    setIsOpenEdit(false)
    form.resetFields();
    setSelected()
  }
  const onCreateClose = () => {
    form.resetFields()
    setIsCreateOpen(false)
    setSelected({})
    setRows([])
  }

  const uploadProps = {
    name: 'file',
    method: 'GET',
    multiple: true,
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
    },
  };

//   const handleView = ({target:{id}}) => {
//     onViewOpen()
//   }
const {
  data: getProductsColorData,
  refetch: getProductsColorFetch,
  isFetching: getProductsLoad,
} = useGetProductColors()

const successAction = () => {
  getProductsColorFetch()
  form.resetFields();
  setSelected()
  onCloseEdit()
  onCreateClose()
};

  const handleEdit = (d) => {
    setIsOpenEdit(true)
    setCreatePayload({
      name:d?.name,
      color:d?.color,
      id:d?.id
    })
  }
  const {
    mutate: postProductAction,
    isLoading: postRoleLoad,
  } = usePostProductColor(successAction)
  
  const {
    mutate: putProductAction,
    isLoading: putProductLoad,
  } = usePatchProductColor(successAction)

  const {
    mutate: deleteProductColorAction,
    isLoading: deleteProductColorLoad,
  } = useDeleteProductColor(successAction)

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key:"name",
      render: (e) => <div className='flex items-center gap-3'>
        {/* <Avatar src="">CF</Avatar> */}
        <p className='text-sm font-medium text-dim'>{e}</p>
      </div>,
    },
    {
      title: "Color",
      dataIndex: "color",
      key:"color",
    },
    {
      title: "Action",
      dataIndex: "",
      render: (data,idx) => <Dropdown
        key={idx}
        trigger={["click"]}
        placement="bottomLeft"
        menu={{items: [
          {key: "edit", label: <button className='flex' id='' onClick={()=>handleEdit(data)}><BiEdit className='!text-base mx-4 py-auto' /> Edit</button>},
          {key: "delete", label: <button className='flex' onClick={() => handleConfirm({data: data?.id, action: deleteProductColorAction})}> <GoTrash className='!text-base mx-4 py-auto' /> Delete</button>},

        ]}}
      >
        <Button loading={deleteProductColorLoad} className='!bg-[#F2F6FC]' type='text' icon={<PiDotsThreeOutlineBold />} />
      </Dropdown>
    },
  ]
  const onSubmit = (d) => {
    postProductAction(d)
    console.log(d)
  }
  const onSubmitEdit = () => {
    putProductAction(createPayload)
  }
  return (
    <PadContainer loading={getProductsLoad}>
      <TitleContainer
        path={false}
        title="Products Status"
        className="border border-lit rounded-xl"
        action={<Button onClick={onCreateOpen} className='!bg-light_blue' type='primary' size='large' icon={<FaPlus />}>Add Products</Button>}
      >
        <CustomTable
          pagination={10}
          column={columns}
          data={getProductsColorData?.data?.data || []}
          rowSelection={handleTableSelect(rows, setRows, "_id")}
        />
      </TitleContainer>


      {/* create edit drawer */}
      <Drawer
        open={isCreateOpen}
        onClose={onCreateClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>New Product</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          className='relative'
        >
          <Form.Item label="Name" name="name" rules={[{required: true, message: 'Please input Name!',},]}>
            <Input size='large' placeholder='Name' />
          </Form.Item>
          <Form.Item label="Color" name="color" rules={[{required: true, message: 'Please input Color!',},]}>
            <Input size='large' placeholder='Color' />
          </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={postRoleLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>

      <Drawer
        open={isOpenEdit}
        onClose={onCloseEdit}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Edit Brand</p>}
      >
        
        <Form
          layout="vertical"
        //   onFinish={onSubmitEdit}
          className='relative'
          form={form}
        >
          <Form.Item label="Name" rules={[{required: true, message: 'Please input Name!',},]}>
            <Input 
                size='large' 
                placeholder='Edit name' 
                prefix={<BiUser />} 
                value={createPayload.name}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, name: value})}
            />
          </Form.Item>
          <Form.Item label="Color" rules={[{required: true, message: 'Please input Name!',},]}>
            <Input 
                size='large' 
                placeholder='Edit Color' 
                value={createPayload.color}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, color: value})}
            />
          </Form.Item>

          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCloseEdit} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' onClick={onSubmitEdit} loading={putProductLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Update</Button>
          </div>
        </Form>
      </Drawer>

      {/* view drawer */}
      <Drawer
        open={isViewOpen}
        onClose={onViewClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Product</p>}
      >
        <div className='w-full'>
          <div className='flex gap-3 items-center'>
            <Image alt='Product image' src={eventImage} />
            <div className='space-y-3'>
              <p className='text-2xl font-bold text-light_blue'>Kings’s Day Parade</p>
              <Tag className={`${statusType?.info?.bg} ${statusType?.secondary?.col} ${statusType?.info?.bd} font-bold rounded-2xl px-3 py-0.5`}>Active</Tag>
            </div>
          </div>
          <Divider />
          <div className='w-full rounded-xl bg-[#FEFAF2] px-5 divide-y'>
            {[
              {Icon: CiLocationOn, value: "Mandeville"},
              {Icon: ImStopwatch, value: "2pm"},
              {Icon: CiCalendarDate, value: "12 December, 2023"},
            ].map(({Icon, value}) => (
              <div className='flex items-center gap-3 py-5'>
                <Button className='!bg-[#FDE9C2] !text-[#F5A302]' icon={<Icon className="!text-xl" />} shape='circle' size='large' type='primary' />
                <p className='text-lg font-semibold text-silver'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            {[
              {label: "Route From", value: "Lagos"},
              {label: "Route To", value: "Germany"},
              {label: "Category", value: "Music and Entertainment"},
              {label: "Created by", value: "Admin"},
            ].map(({label, value}) => (
              <div className='flex items-center gap-3'>
                <p className='text-base text-light_blue font-semibold'>{label}: </p>
                <p className='text-base text-dim font-medium'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 flex justify-between items-center'>
            <div className='flex items-center gap-5'>
              <p className='text-base text-light_blue font-semibold'>Attendees:</p>
              <Avatar.Group
                maxCount={4}
                maxPopoverTrigger="click"
                maxStyle={{ color: '#F5A302', backgroundColor: '#002C70', cursor: 'pointer' }}
              >
                {Array.from(Array(100).keys()).map(idx => (
                  <Avatar>{idx}</Avatar>
                ))}
              </Avatar.Group>
            </div>
            <Button className='!bg-lint text-dim' type='primary' size='small'>View All</Button>
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            <p className='text-base text-light_blue font-semibold'>Description</p>
            <p className='text-sm text-dim font-normal'>Celebrate the vibrant spirit of our community at our annual Parade Spectacular! Join us for a lively and colourful procession weaving through the heart of [City/Town Name], featuring magnificent floats, marching bands, and dazzling performances.</p>
          </div>
          <Divider />
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={handleEdit} loading={false} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Edit</Button>
            <Button className='!text-light_blue !border-light_blue' size='large'>Delete</Button>
          </div>
        </div>
      </Drawer>
    </PadContainer>
  )
}

export default ProductColorTab